<div class="home-container">
  <div class="logo-container">
    <img src="assets/img/logo.png" alt="" />
  </div>

  
	<div class="description-container">
	<!--	<div class="wifilogo-container">
			<mat-icon svgIcon="wifi" aria-hidden="false"></mat-icon>
		</div> -->
		Découvrez notre carte et appelez votre serveur sans attendre ! 

		<!--<div class="infoWifi-container">

			<div class="infoWifi">
				Nom du réseau : SFR-25a1<br>
				Clé de sécurité : CaptainPub2020
			</div>

		</div>-->
	</div>
	

  <button
    mat-flat-button
    class="appbutton"
    color="primary"
    routerLink="/carte/{{ id }}"
  >
    Accéder à la carte
  </button>
  
</div>
